// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-descirption{max-height:0;overflow:hidden;transition:max-height .5s cubic-bezier(0,1,0,1)}.active .dropdown-descirption{max-height:1000px;transition:max-height 1s ease-in-out}.active .plus-active{--transform-rotate:45deg}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
